import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import MAP_VIEW from "./views/Map.view";
import DASHBOARD_VIEW from "./views/Dashboard.view";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./state-management/root-reducer";
import {
  fetchAppConfig,
  setLoading,
} from "./state-management/slices/global/global.slice";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

function App(): React.ReactElement | null {
  const dispatch = useDispatch();
  const history = useHistory();

  const pca = useRef<PublicClientApplication | null>(null);

  // App State
  const { appConfig, ui } = useSelector(
    (state: RootState) => state.globalState
  );

  const [appConfigLoaded, setappConfigLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!appConfig && !ui.loading) {
      dispatch(setLoading(true));
      dispatch(fetchAppConfig());
    }

    if (appConfig !== null) {
      const msalConfig: any = {
        auth: {
          tenantId: appConfig?.azureTenantId,
          clientId: appConfig?.azureClientId,
          authority: appConfig?.azureAuthority,
          redirectUri: appConfig?.azureRedirectUri,
          postLogoutRedirectUri: "/",
          navigateToLoginRequestUrl: false,
        },
        cache: {
          cacheLocation: "sessionStorage", // This configures where your cache will be stored
          storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
        system: {
          allowNativeBroker: false, // Disables native brokering support
        },
      };
      pca.current = new PublicClientApplication(msalConfig);

      pca.current
        .handleRedirectPromise()
        .then((s) => {
          // to handle redirection with custom config
        })
        .catch((a) => {
          // to handle redirection with custom config
        });

      setappConfigLoaded(true);
    }
  }, [appConfig, dispatch, ui.loading]);

  return (
    appConfig &&
    pca.current && (
      <MsalProvider instance={pca.current}>
        <Router>
          <Switch>
            <Route exact path="/" component={MAP_VIEW} />
            <Route exact path="/dashboard" component={DASHBOARD_VIEW} />
            <Route path="*" component={MAP_VIEW} />
          </Switch>
        </Router>
      </MsalProvider>
    )
  );
}

export default App;
